const CURRENCY = [
  {
    id: '1',
    title: 'United States (Dollar)',
    currency: 'USD',
    code: 'en-US',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/us.png',
  },
  {
    id: '2',
    title: 'India (Rupee)',
    currency: 'INR',
    code: 'en-IN',
    symbol: '\u20b9',
    flag: 'https://flagcdn.com/w80/in.png',
  },
  {
    id: '3',
    title: 'United Kingdom (Pound)',
    currency: 'GBP',
    code: 'en-GB',
    symbol: '£',
    flag: 'https://flagcdn.com/w80/gb.png',
  },
  {
    id: '4',
    title: 'European Union (Euro)',
    currency: 'EUR',
    code: 'de-DE',
    symbol: '€',
    flag: 'https://flagcdn.com/w80/eu.png',
  },
  {
    id: '5',
    title: 'Australia (Dollar)',
    currency: 'AUD',
    code: 'en-AU',
    symbol: 'A$',
    flag: 'https://flagcdn.com/w80/au.png',
  },
  {
    id: '6',
    title: 'Canada (Dollar)',
    currency: 'CAD',
    code: 'en-CA',
    symbol: 'C$',
    flag: 'https://flagcdn.com/w80/ca.png',
  },
  {
    id: '7',
    title: 'China (Yuan)',
    currency: 'CNY',
    code: 'zh-CN',
    symbol: '¥',
    flag: 'https://flagcdn.com/w80/cn.png',
  },
  {
    id: '8',
    title: 'Japan (Yen)',
    currency: 'JPY',
    code: 'ja-JP',
    symbol: '\u00a5',
    flag: 'https://flagcdn.com/w80/jp.png',
  },
  {
    id: '9',
    title: 'Brazil (Real)',
    currency: 'BRL',
    code: 'pt-BR',
    symbol: 'R$',
    flag: 'https://flagcdn.com/w80/br.png',
  },
  {
    id: '10',
    title: 'Russia (Ruble)',
    currency: 'RUB',
    code: 'ru-RU',
    symbol: '\u20bd',
    flag: 'https://flagcdn.com/w80/ru.png',
  },
  {
    id: '11',
    title: 'South Korea (Won)',
    currency: 'KRW',
    code: 'ko-KR',
    symbol: '\u20a9',
    flag: 'https://flagcdn.com/w80/kr.png',
  },
  {
    id: '12',
    title: 'South Africa (Rand)',
    currency: 'ZAR',
    code: 'en-ZA',
    symbol: 'R',
    flag: 'https://flagcdn.com/w80/za.png',
  },
  {
    id: '13',
    title: 'Turkey (Lira)',
    currency: 'TRY',
    code: 'tr-TR',
    symbol: '\u20ba',
    flag: 'https://flagcdn.com/w80/tr.png',
  },
  {
    id: '14',
    title: 'Sweden (Krona)',
    currency: 'SEK',
    code: 'sv-SE',
    symbol: 'kr',
    flag: 'https://flagcdn.com/w80/se.png',
  },
  {
    id: '15',
    title: 'Norway (Krone)',
    currency: 'NOK',
    code: 'nb-NO',
    symbol: 'kr',
    flag: 'https://flagcdn.com/w80/no.png',
  },
  {
    id: '16',
    title: 'Denmark (Krone)',
    currency: 'DKK',
    code: 'da-DK',
    symbol: 'kr',
    flag: 'https://flagcdn.com/w80/dk.png',
  },
  {
    id: '17',
    title: 'Poland (Zloty)',
    currency: 'PLN',
    code: 'pl-PL',
    symbol: 'z\u0142',
    flag: 'https://flagcdn.com/w80/pl.png',
  },
  {
    id: '18',
    title: 'Switzerland (Franc)',
    currency: 'CHF',
    code: 'de-CH',
    symbol: 'CHF',
    flag: 'https://flagcdn.com/w80/ch.png',
  },
  {
    id: '19',
    title: 'Singapore (Dollar)',
    currency: 'SGD',
    code: 'en-SG',
    symbol: 'S$',
    flag: 'https://flagcdn.com/w80/sg.png',
  },
  {
    id: '20',
    title: 'Mexico (Peso)',
    currency: 'MXN',
    code: 'es-MX',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/mx.png',
  },
  {
    id: '21',
    title: 'Taiwan (Dollar)',
    currency: 'TWD',
    code: 'zh-TW',
    symbol: 'NT$',
    flag: 'https://flagcdn.com/w80/tw.png',
  },
  {
    id: '22',
    title: 'Hong Kong (Dollar)',
    currency: 'HKD',
    code: 'zh-HK',
    symbol: 'HK$',
    flag: 'https://flagcdn.com/w80/hk.png',
  },
  {
    id: '23',
    title: 'Thailand (Baht)',
    currency: 'THB',
    code: 'th-TH',
    symbol: '\u0e3f',
    flag: 'https://flagcdn.com/w80/th.png',
  },
  {
    id: '24',
    title: 'Malaysia (Ringgit)',
    currency: 'MYR',
    code: 'ms-MY',
    symbol: 'RM',
    flag: 'https://flagcdn.com/w80/my.png',
  },
  {
    id: '25',
    title: 'Indonesia (Rupiah)',
    currency: 'IDR',
    code: 'id-ID',
    symbol: 'Rp',
    flag: 'https://flagcdn.com/w80/id.png',
  },
  {
    id: '26',
    title: "Philippines тварин: 'Peso'",
    currency: 'PHP',
    code: 'en-PH',
    symbol: '\u20b1',
    flag: 'https://flagcdn.com/w80/ph.png',
  },
  {
    id: '27',
    title: 'Vietnam (Dong)',
    currency: 'VND',
    code: 'vi-VN',
    symbol: '\u20ab',
    flag: 'https://flagcdn.com/w80/vn.png',
  },
  {
    id: '28',
    title: 'United Arab Emirates (Dirham)',
    currency: 'AED',
    code: 'ar-AE',
    symbol: 'د.إ',
    flag: 'https://flagcdn.com/w80/ae.png',
  },
  {
    id: '29',
    title: 'Afghanistan (Afghani)',
    currency: 'AFN',
    code: 'fa-AF',
    symbol: '؋',
    flag: 'https://flagcdn.com/w80/af.png',
  },
  {
    id: '30',
    title: 'Albania (Lek)',
    currency: 'ALL',
    code: 'sq-AL',
    symbol: 'Lek',
    flag: 'https://flagcdn.com/w80/al.png',
  },
  {
    id: '31',
    title: 'Armenia (Dram)',
    currency: 'AMD',
    code: 'hy-AM',
    symbol: '֏',
    flag: 'https://flagcdn.com/w80/am.png',
  },
  {
    id: '32',
    title: 'Curaçao (Netherlands Antillean Guilder)',
    currency: 'ANG',
    code: 'nl-CW',
    symbol: 'ƒ',
    flag: 'https://flagcdn.com/w80/cw.png',
  },
  {
    id: '33',
    title: 'Angola (Kwanza)',
    currency: 'AOA',
    code: 'pt-AO',
    symbol: 'Kz',
    flag: 'https://flagcdn.com/w80/ao.png',
  },
  {
    id: '34',
    title: 'Argentina (Peso)',
    currency: 'ARS',
    code: 'es-AR',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/ar.png',
  },
  {
    id: '35',
    title: 'Bermuda (Dollar)',
    currency: 'BMD',
    code: 'en-BM',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/bm.png',
  },
  {
    id: '36',
    title: 'Brunei (Dollar)',
    currency: 'BND',
    code: 'ms-BN',
    symbol: 'B$',
    flag: 'https://flagcdn.com/w80/bn.png',
  },
  {
    id: '37',
    title: 'Bolivia (Boliviano)',
    currency: 'BOB',
    code: 'es-BO',
    symbol: 'Bs',
    flag: 'https://flagcdn.com/w80/bo.png',
  },
  {
    id: '38',
    title: 'Bahamas (Dollar)',
    currency: 'BSD',
    code: 'en-BS',
    symbol: 'B$',
    flag: 'https://flagcdn.com/w80/bs.png',
  },
  {
    id: '39',
    title: 'Bhutan (Ngultrum)',
    currency: 'BTN',
    code: 'dz-BT',
    symbol: 'Nu.',
    flag: 'https://flagcdn.com/w80/bt.png',
  },
  {
    id: '40',
    title: 'Botswana (Pula)',
    currency: 'BWP',
    code: 'en-BW',
    symbol: 'P',
    flag: 'https://flagcdn.com/w80/bw.png',
  },
  {
    id: '41',
    title: 'Belarus (Ruble)',
    currency: 'BYN',
    code: 'be-BY',
    symbol: 'Br',
    flag: 'https://flagcdn.com/w80/by.png',
  },
  {
    id: '42',
    title: 'Aruba (Florin)',
    currency: 'AWG',
    code: 'nl-AW',
    symbol: 'ƒ',
    flag: 'https://flagcdn.com/w80/aw.png',
  },
  {
    id: '43',
    title: 'Azerbaijan (Manat)',
    currency: 'AZN',
    code: 'az-AZ',
    symbol: '₼',
    flag: 'https://flagcdn.com/w80/az.png',
  },
  {
    id: '44',
    title: 'Bosnia and Herzegovina (Convertible Mark)',
    currency: 'BAM',
    code: 'bs-BA',
    symbol: 'KM',
    flag: 'https://flagcdn.com/w80/ba.png',
  },
  {
    id: '45',
    title: 'Barbados (Dollar)',
    currency: 'BBD',
    code: 'en-BB',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/bb.png',
  },
  {
    id: '46',
    title: 'Bangladesh (Taka)',
    currency: 'BDT',
    code: 'bn-BD',
    symbol: '৳',
    flag: 'https://flagcdn.com/w80/bd.png',
  },
  {
    id: '47',
    title: 'Bulgaria (Lev)',
    currency: 'BGN',
    code: 'bg-BG',
    symbol: 'лв',
    flag: 'https://flagcdn.com/w80/bg.png',
  },
  {
    id: '48',
    title: 'Bahrain (Dinar)',
    currency: 'BHD',
    code: 'ar-BH',
    symbol: '.د.ب',
    flag: 'https://flagcdn.com/w80/bh.png',
  },
  {
    id: '49',
    title: 'Burundi (Franc)',
    currency: 'BIF',
    code: 'fr-BI',
    symbol: 'FBu',
    flag: 'https://flagcdn.com/w80/bi.png',
  },
  {
    id: '50',
    title: 'Belize (Dollar)',
    currency: 'BZD',
    code: 'en-BZ',
    symbol: 'BZ$',
    flag: 'https://flagcdn.com/w80/bz.png',
  },
  {
    id: '51',
    title: 'Congo (Congolese Franc)',
    currency: 'CDF',
    code: 'fr-CD',
    symbol: 'FC',
    flag: 'https://flagcdn.com/w80/cd.png',
  },
  {
    id: '52',
    title: 'Chile (Peso)',
    currency: 'CLP',
    code: 'es-CL',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/cl.png',
  },
  {
    id: '53',
    title: 'Colombia (Peso)',
    currency: 'COP',
    code: 'es-CO',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/co.png',
  },
  {
    id: '54',
    title: 'Costa Rica (Colon)',
    currency: 'CRC',
    code: 'es-CR',
    symbol: '₡',
    flag: 'https://flagcdn.com/w80/cr.png',
  },
  {
    id: '55',
    title: 'Cuba (Peso)',
    currency: 'CUP',
    code: 'es-CU',
    symbol: '₱',
    flag: 'https://flagcdn.com/w80/cu.png',
  },
  {
    id: '56',
    title: 'Cape Verde (Escudo)',
    currency: 'CVE',
    code: 'pt-CV',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/cv.png',
  },
  {
    id: '57',
    title: 'Czech Republic (Koruna)',
    currency: 'CZK',
    code: 'cs-CZ',
    symbol: 'Kč',
    flag: 'https://flagcdn.com/w80/cz.png',
  },
  {
    id: '58',
    title: 'Djibouti (Franc)',
    currency: 'DJF',
    code: 'fr-DJ',
    symbol: 'Fdj',
    flag: 'https://flagcdn.com/w80/dj.png',
  },
  {
    id: '59',
    title: 'Dominican Republic (Peso)',
    currency: 'DOP',
    code: 'es-DO',
    symbol: 'RD$',
    flag: 'https://flagcdn.com/w80/do.png',
  },
  {
    id: '60',
    title: 'Algeria (Dinar)',
    currency: 'DZD',
    code: 'ar-DZ',
    symbol: 'دج',
    flag: 'https://flagcdn.com/w80/dz.png',
  },
  {
    id: '61',
    title: 'Egypt (Pound)',
    currency: 'EGP',
    code: 'ar-EG',
    symbol: '£',
    flag: 'https://flagcdn.com/w80/eg.png',
  },
  {
    id: '62',
    title: 'Eritrea (Nakfa)',
    currency: 'ERN',
    code: 'ti-ER',
    symbol: 'Nfk',
    flag: 'https://flagcdn.com/w80/er.png',
  },
  {
    id: '63',
    title: 'Ethiopia (Birr)',
    currency: 'ETB',
    code: 'am-ET',
    symbol: 'Br',
    flag: 'https://flagcdn.com/w80/et.png',
  },
  {
    id: '64',
    title: 'Fiji (Dollar)',
    currency: 'FJD',
    code: 'en-FJ',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/fj.png',
  },
  {
    id: '65',
    title: 'Falkland Islands (Pound)',
    currency: 'FKP',
    code: 'en-FK',
    symbol: '£',
    flag: 'https://flagcdn.com/w80/fk.png',
  },
  {
    id: '66',
    title: 'Faroe Islands (Krone)',
    currency: 'FOK',
    code: 'fo-FO',
    symbol: 'kr',
    flag: 'https://flagcdn.com/w80/fo.png',
  },
  {
    id: '67',
    title: 'Georgia (Lari)',
    currency: 'GEL',
    code: 'ka-GE',
    symbol: '₾',
    flag: 'https://flagcdn.com/w80/ge.png',
  },
  {
    id: '68',
    title: 'Guernsey (Pound)',
    currency: 'GGP',
    code: 'en-GG',
    symbol: '£',
    flag: 'https://flagcdn.com/w80/gg.png',
  },
  {
    id: '69',
    title: 'Ghana (Cedi)',
    currency: 'GHS',
    code: 'en-GH',
    symbol: '₵',
    flag: 'https://flagcdn.com/w80/gh.png',
  },
  {
    id: '70',
    title: 'Gibraltar (Pound)',
    currency: 'GIP',
    code: 'en-GI',
    symbol: '£',
    flag: 'https://flagcdn.com/w80/gi.png',
  },
  {
    id: '71',
    title: 'Gambia (Dalasi)',
    currency: 'GMD',
    code: 'en-GM',
    symbol: 'D',
    flag: 'https://flagcdn.com/w80/gm.png',
  },
  {
    id: '72',
    title: 'Guinea (Franc)',
    currency: 'GNF',
    code: 'fr-GN',
    symbol: 'FG',
    flag: 'https://flagcdn.com/w80/gn.png',
  },
  {
    id: '73',
    title: 'Guatemala (Quetzal)',
    currency: 'GTQ',
    code: 'es-GT',
    symbol: 'Q',
    flag: 'https://flagcdn.com/w80/gt.png',
  },
  {
    id: '74',
    title: 'Guyana (Dollar)',
    currency: 'GYD',
    code: 'en-GY',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/gy.png',
  },
  {
    id: '75',
    title: 'Honduras (Lempira)',
    currency: 'HNL',
    code: 'es-HN',
    symbol: 'L',
    flag: 'https://flagcdn.com/w80/hn.png',
  },
  {
    id: '76',
    title: 'Croatia (Kuna)',
    currency: 'HRK',
    code: 'hr-HR',
    symbol: 'kn',
    flag: 'https://flagcdn.com/w80/hr.png',
  },
  {
    id: '77',
    title: 'Haiti (Gourde)',
    currency: 'HTG',
    code: 'ht-HT',
    symbol: 'G',
    flag: 'https://flagcdn.com/w80/ht.png',
  },
  {
    id: '78',
    title: 'Hungary (Forint)',
    currency: 'HUF',
    code: 'hu-HU',
    symbol: 'Ft',
    flag: 'https://flagcdn.com/w80/hu.png',
  },
  {
    id: '79',
    title: 'Israel (Shekel)',
    currency: 'ILS',
    code: 'he-IL',
    symbol: '₪',
    flag: 'https://flagcdn.com/w80/il.png',
  },
  {
    id: '80',
    title: 'Isle of Man (Pound)',
    currency: 'IMP',
    code: 'en-IM',
    symbol: '£',
    flag: 'https://flagcdn.com/w80/im.png',
  },
  {
    id: '81',
    title: 'Iraq (Dinar)',
    currency: 'IQD',
    code: 'ar-IQ',
    symbol: 'ع.د',
    flag: 'https://flagcdn.com/w80/iq.png',
  },
  {
    id: '82',
    title: 'Iran (Rial)',
    currency: 'IRR',
    code: 'fa-IR',
    symbol: '﷼',
    flag: 'https://flagcdn.com/w80/ir.png',
  },
  {
    id: '83',
    title: 'Iceland (Krona)',
    currency: 'ISK',
    code: 'is-IS',
    symbol: 'kr',
    flag: 'https://flagcdn.com/w80/is.png',
  },
  {
    id: '84',
    title: 'Jamaica (Dollar)',
    currency: 'JMD',
    code: 'en-JM',
    symbol: 'J$',
    flag: 'https://flagcdn.com/w80/jm.png',
  },
  {
    id: '85',
    title: 'Jordan (Dinar)',
    currency: 'JOD',
    code: 'ar-JO',
    symbol: 'JD',
    flag: 'https://flagcdn.com/w80/jo.png',
  },
  {
    id: '86',
    title: 'Kenya (Shilling)',
    currency: 'KES',
    code: 'sw-KE',
    symbol: 'KSh',
    flag: 'https://flagcdn.com/w80/ke.png',
  },
  {
    id: '87',
    title: 'Kyrgyzstan (Som)',
    currency: 'KGS',
    code: 'ky-KG',
    symbol: 'лв',
    flag: 'https://flagcdn.com/w80/kg.png',
  },
  {
    id: '88',
    title: 'Cambodia (Riel)',
    currency: 'KHR',
    code: 'km-KH',
    symbol: '៛',
    flag: 'https://flagcdn.com/w80/kh.png',
  },
  {
    id: '89',
    title: 'Kiribati (Dollar)',
    currency: 'KID',
    code: 'en-KI',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/ki.png',
  },
  {
    id: '90',
    title: 'Comoros (Franc)',
    currency: 'KMF',
    code: 'ar-KM',
    symbol: 'CF',
    flag: 'https://flagcdn.com/w80/km.png',
  },
  {
    id: '91',
    title: 'Kuwait (Dinar)',
    currency: 'KWD',
    code: 'ar-KW',
    symbol: 'KD',
    flag: 'https://flagcdn.com/w80/kw.png',
  },
  {
    id: '92',
    title: 'Cayman Islands (Dollar)',
    currency: 'KYD',
    code: 'en-KY',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/ky.png',
  },
  {
    id: '93',
    title: 'Kazakhstan (Tenge)',
    currency: 'KZT',
    code: 'kk-KZ',
    symbol: '₸',
    flag: 'https://flagcdn.com/w80/kz.png',
  },
  {
    id: '94',
    title: 'Laos (Kip)',
    currency: 'LAK',
    code: 'lo-LA',
    symbol: '₭',
    flag: 'https://flagcdn.com/w80/la.png',
  },
  {
    id: '95',
    title: 'Lebanon (Pound)',
    currency: 'LBP',
    code: 'ar-LB',
    symbol: 'ل.ل',
    flag: 'https://flagcdn.com/w80/lb.png',
  },
  {
    id: '96',
    title: 'Sri Lanka (Rupee)',
    currency: 'LKR',
    code: 'si-LK',
    symbol: '₨',
    flag: 'https://flagcdn.com/w80/lk.png',
  },
  {
    id: '97',
    title: 'Liberia (Dollar)',
    currency: 'LRD',
    code: 'en-LR',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/lr.png',
  },
  {
    id: '98',
    title: 'Lesotho (Loti)',
    currency: 'LSL',
    code: 'st-LS',
    symbol: 'L',
    flag: 'https://flagcdn.com/w80/ls.png',
  },
  {
    id: '99',
    title: 'Libya (Dinar)',
    currency: 'LYD',
    code: 'ar-LY',
    symbol: 'LD',
    flag: 'https://flagcdn.com/w80/ly.png',
  },
  {
    id: '100',
    title: 'Morocco (Dirham)',
    currency: 'MAD',
    code: 'ar-MA',
    symbol: 'DH',
    flag: 'https://flagcdn.com/w80/ma.png',
  },
  {
    id: '101',
    title: 'Moldova (Leu)',
    currency: 'MDL',
    code: 'ro-MD',
    symbol: 'L',
    flag: 'https://flagcdn.com/w80/md.png',
  },
  {
    id: '102',
    title: 'Madagascar (Ariary)',
    currency: 'MGA',
    code: 'mg-MG',
    symbol: 'Ar',
    flag: 'https://flagcdn.com/w80/mg.png',
  },
  {
    id: '103',
    title: 'Macedonia (Denar)',
    currency: 'MKD',
    code: 'mk-MK',
    symbol: 'ден',
    flag: 'https://flagcdn.com/w80/mk.png',
  },
  {
    id: '104',
    title: 'Myanmar (Kyat)',
    currency: 'MMK',
    code: 'my-MM',
    symbol: 'K',
    flag: 'https://flagcdn.com/w80/mm.png',
  },
  {
    id: '105',
    title: 'Mongolia (Tugrik)',
    currency: 'MNT',
    code: 'mn-MN',
    symbol: '₮',
    flag: 'https://flagcdn.com/w80/mn.png',
  },
  {
    id: '106',
    title: 'Macau (Pataca)',
    currency: 'MOP',
    code: 'zh-MO',
    symbol: 'MOP$',
    flag: 'https://flagcdn.com/w80/mo.png',
  },
  {
    id: '107',
    title: 'Mauritania (Ouguiya)',
    currency: 'MRU',
    code: 'ar-MR',
    symbol: 'UM',
    flag: 'https://flagcdn.com/w80/mr.png',
  },
  {
    id: '108',
    title: 'Mauritius (Rupee)',
    currency: 'MUR',
    code: 'en-MU',
    symbol: '₨',
    flag: 'https://flagcdn.com/w80/mu.png',
  },
  {
    id: '109',
    title: 'Maldives (Rufiyaa)',
    currency: 'MVR',
    code: 'dv-MV',
    symbol: 'Rf',
    flag: 'https://flagcdn.com/w80/mv.png',
  },
  {
    id: '110',
    title: 'Malawi (Kwacha)',
    currency: 'MWK',
    code: 'en-MW',
    symbol: 'MK',
    flag: 'https://flagcdn.com/w80/mw.png',
  },
  {
    id: '111',
    title: 'Mozambique (Metical)',
    currency: 'MZN',
    code: 'pt-MZ',
    symbol: 'MT',
    flag: 'https://flagcdn.com/w80/mz.png',
  },
  {
    id: '112',
    title: 'Namibia (Dollar)',
    currency: 'NAD',
    code: 'en-NA',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/na.png',
  },
  {
    id: '113',
    title: 'Nigeria (Naira)',
    currency: 'NGN',
    code: 'en-NG',
    symbol: '₦',
    flag: 'https://flagcdn.com/w80/ng.png',
  },
  {
    id: '114',
    title: 'Nicaragua (Cordoba)',
    currency: 'NIO',
    code: 'es-NI',
    symbol: 'C$',
    flag: 'https://flagcdn.com/w80/ni.png',
  },
  {
    id: '115',
    title: 'Nepal (Rupee)',
    currency: 'NPR',
    code: 'ne-NP',
    symbol: '₨',
    flag: 'https://flagcdn.com/w80/np.png',
  },
  {
    id: '116',
    title: 'New Zealand (Dollar)',
    currency: 'NZD',
    code: 'en-NZ',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/nz.png',
  },
  {
    id: '117',
    title: 'Oman (Rial)',
    currency: 'OMR',
    code: 'ar-OM',
    symbol: '﷼',
    flag: 'https://flagcdn.com/w80/om.png',
  },
  {
    id: '118',
    title: 'Panama (Balboa)',
    currency: 'PAB',
    code: 'es-PA',
    symbol: 'B/.',
    flag: 'https://flagcdn.com/w80/pa.png',
  },
  {
    id: '119',
    title: 'Peru (Sol)',
    currency: 'PEN',
    code: 'es-PE',
    symbol: 'S/.',
    flag: 'https://flagcdn.com/w80/pe.png',
  },
  {
    id: '120',
    title: 'Papua New Guinea (Kina)',
    currency: 'PGK',
    code: 'en-PG',
    symbol: 'K',
    flag: 'https://flagcdn.com/w80/pg.png',
  },
  {
    id: '121',
    title: 'Pakistan (Rupee)',
    currency: 'PKR',
    code: 'ur-PK',
    symbol: '₨',
    flag: 'https://flagcdn.com/w80/pk.png',
  },
  {
    id: '122',
    title: 'Paraguay (Guarani)',
    currency: 'PYG',
    code: 'es-PY',
    symbol: '₲',
    flag: 'https://flagcdn.com/w80/py.png',
  },
  {
    id: '123',
    title: 'Qatar (Riyal)',
    currency: 'QAR',
    code: 'ar-QA',
    symbol: '﷼',
    flag: 'https://flagcdn.com/w80/qa.png',
  },
  {
    id: '124',
    title: 'Romania (Leu)',
    currency: 'RON',
    code: 'ro-RO',
    symbol: 'lei',
    flag: 'https://flagcdn.com/w80/ro.png',
  },
  {
    id: '125',
    title: 'Serbia (Dinar)',
    currency: 'RSD',
    code: 'sr-RS',
    symbol: 'Дин.',
    flag: 'https://flagcdn.com/w80/rs.png',
  },
  {
    id: '126',
    title: 'Rwanda (Franc)',
    currency: 'RWF',
    code: 'rw-RW',
    symbol: 'R₣',
    flag: 'https://flagcdn.com/w80/rw.png',
  },
  {
    id: '127',
    title: 'Saudi Arabia (Riyal)',
    currency: 'SAR',
    code: 'ar-SA',
    symbol: '﷼',
    flag: 'https://flagcdn.com/w80/sa.png',
  },
  {
    id: '128',
    title: 'Solomon Islands (Dollar)',
    currency: 'SBD',
    code: 'en-SB',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/sb.png',
  },
  {
    id: '129',
    title: 'Seychelles (Rupee)',
    currency: 'SCR',
    code: 'en-SC',
    symbol: '₨',
    flag: 'https://flagcdn.com/w80/sc.png',
  },
  {
    id: '130',
    title: 'Sudan (Pound)',
    currency: 'SDG',
    code: 'ar-SD',
    symbol: 'SDG',
    flag: 'https://flagcdn.com/w80/sd.png',
  },
  {
    id: '131',
    title: 'Sierra Leone (Leone)',
    currency: 'SLE',
    code: 'en-SL',
    symbol: 'Le',
    flag: 'https://flagcdn.com/w80/sl.png',
  },
  {
    id: '132',
    title: 'South Sudan (Pound)',
    currency: 'SSP',
    code: 'en-SS',
    symbol: '£',
    flag: 'https://flagcdn.com/w80/ss.png',
  },
  {
    id: '133',
    title: 'São Tomé and Príncipe (Dobra)',
    currency: 'STN',
    code: 'pt-ST',
    symbol: 'Db',
    flag: 'https://flagcdn.com/w80/st.png',
  },
  {
    id: '134',
    title: 'Syria (Pound)',
    currency: 'SYP',
    code: 'ar-SY',
    symbol: '£',
    flag: 'https://flagcdn.com/w80/sy.png',
  },
  {
    id: '135',
    title: 'Eswatini (Lilangeni)',
    currency: 'SZL',
    code: 'en-SZ',
    symbol: 'E',
    flag: 'https://flagcdn.com/w80/sz.png',
  },
  {
    id: '136',
    title: 'Tajikistan (Somoni)',
    currency: 'TJS',
    code: 'tg-TJ',
    symbol: 'SM',
    flag: 'https://flagcdn.com/w80/tj.png',
  },
  {
    id: '137',
    title: 'Turkmenistan (Manat)',
    currency: 'TMT',
    code: 'tk-TM',
    symbol: 'T',
    flag: 'https://flagcdn.com/w80/tm.png',
  },
  {
    id: '138',
    title: 'Tunisia (Dinar)',
    currency: 'TND',
    code: 'ar-TN',
    symbol: 'DT',
    flag: 'https://flagcdn.com/w80/tn.png',
  },
  {
    id: '139',
    title: 'Tonga (Paʻanga)',
    currency: 'TOP',
    code: 'to-TO',
    symbol: 'T$',
    flag: 'https://flagcdn.com/w80/to.png',
  },
  {
    id: '140',
    title: 'Trinidad and Tobago (Dollar)',
    currency: 'TTD',
    code: 'en-TT',
    symbol: 'TT$',
    flag: 'https://flagcdn.com/w80/tt.png',
  },
  {
    id: '141',
    title: 'Tuvalu (Dollar)',
    currency: 'TVD',
    code: 'en-TV',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/tv.png',
  },
  {
    id: '142',
    title: 'Tanzania (Shilling)',
    currency: 'TZS',
    code: 'sw-TZ',
    symbol: 'TSh',
    flag: 'https://flagcdn.com/w80/tz.png',
  },
  {
    id: '143',
    title: 'Ukraine (Hryvnia)',
    currency: 'UAH',
    code: 'uk-UA',
    symbol: '₴',
    flag: 'https://flagcdn.com/w80/ua.png',
  },
  {
    id: '144',
    title: 'Uganda (Shilling)',
    currency: 'UGX',
    code: 'en-UG',
    symbol: 'UGX',
    flag: 'https://flagcdn.com/w80/ug.png',
  },
  {
    id: '145',
    title: 'Uruguay (Peso)',
    currency: 'UYU',
    code: 'es-UY',
    symbol: '$U',
    flag: 'https://flagcdn.com/w80/uy.png',
  },
  {
    id: '146',
    title: 'Uzbekistan (Som)',
    currency: 'UZS',
    code: 'uz-UZ',
    symbol: 'лв',
    flag: 'https://flagcdn.com/w80/uz.png',
  },
  {
    id: '147',
    title: 'Venezuela (Bolívar)',
    currency: 'VES',
    code: 'es-VE',
    symbol: 'Bs',
    flag: 'https://flagcdn.com/w80/ve.png',
  },
  {
    id: '148',
    title: 'Vanuatu (Vatu)',
    currency: 'VUV',
    code: 'en-VU',
    symbol: 'VT',
    flag: 'https://flagcdn.com/w80/vu.png',
  },
  {
    id: '149',
    title: 'Samoa (Tala)',
    currency: 'WST',
    code: 'sm-WS',
    symbol: 'WS$',
    flag: 'https://flagcdn.com/w80/ws.png',
  },
  {
    id: '150',
    title: 'Central African Republic (CFA Franc)',
    currency: 'XAF',
    code: 'fr-CF',
    symbol: 'FCFA',
    flag: 'https://flagcdn.com/w80/cf.png',
  },
  {
    id: '151',
    title: 'East Caribbean (Dollar)',
    currency: 'XCD',
    code: 'en-XC',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/xc.png',
  },
  {
    id: '152',
    title: 'West African CFA Franc (Franc)',
    currency: 'XOF',
    code: 'fr-XOF',
    symbol: 'CFA',
    flag: 'https://flagcdn.com/w80/xof.png',
  },
  {
    id: '153',
    title: 'CFP Franc (Franc)',
    currency: 'XPF',
    code: 'fr-PF',
    symbol: '₣',
    flag: 'https://flagcdn.com/w80/pf.png',
  },
  {
    id: '154',
    title: 'Yemen (Rial)',
    currency: 'YER',
    code: 'ar-YE',
    symbol: '﷼',
    flag: 'https://flagcdn.com/w80/ye.png',
  },
  {
    id: '155',
    title: 'Zambia (Kwacha)',
    currency: 'ZMW',
    code: 'en-ZM',
    symbol: 'K',
    flag: 'https://flagcdn.com/w80/zm.png',
  },
  {
    id: '156',
    title: 'Zimbabwe (Dollar)',
    currency: 'ZWL',
    code: 'en-ZW',
    symbol: '$',
    flag: 'https://flagcdn.com/w80/zw.png',
  },
];

export default CURRENCY;